export type DistributiveOmit<T, K extends keyof T> = T extends unknown
  ? Omit<T, K>
  : never;
export type PartialPick<T, K extends keyof T> = Pick<T, K> & Partial<T>;

export function isNonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

/**
 * Utility type to create a union of string literals and any string.
 * Useful to get type hinting for string constants while allowing any string.
 */
// {} is a hint for a typescript to support string constants and any string
// eslint-disable-next-line @typescript-eslint/ban-types
export type OrAnyString<T extends string> = T | (string & {});
